import get from 'lodash/get';
import { types, types2 } from './types';

const lotTypes = {
    ...types,
    ...types2,
};

const lotStatus = {
    acted: 'Acté',
    retired: 'Retiré vente',
    booked: 'Réservé',
    optionned: 'Optionné',
    available: 'Libre',
};

function formatLotType(value: string) {
    return get(lotTypes, value, value);
}

function formatLotStatus(value: string) {
    return get(lotStatus, value, value);
}

export { lotTypes, lotStatus, formatLotType, formatLotStatus };
